import React, { forwardRef } from "react";
import PrizeSlotsCounter from "../PrizeSlotsCounter/PrizeSlotsCounter";
import {FormattedMessage} from "react-intl";
import "./PreSelectedPrizeCard.style.scss";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import _ from "lodash";
import {useGetRollingPrizeQuery} from "../../stores/pickX/pickX.api";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import {useSelector} from "react-redux";
import {selectLocale, selectUserCultureLg} from "../../stores/account/account.selectors";
import TournamentTimer from "../TournamentTimer/TournamentTimer";
import moment from "moment/moment";
import ParlayCancelled from "../ParlayCancelled/ParlayCancelled";
import {getLeagueBySportId} from "../../utils/SportUtils";
import {PayoutModel} from "../../constants/PickXEnums";
import {selectPartnerById, selectPrizeAssetById} from "../../stores/pickX/pickX.selectors";
import {Link} from "react-router-dom";

const PreSelectedPrizeCard = forwardRef(({parlay, showDecimal}, ref) => {

    let Component = null;
    switch(parlay.PayoutModel) {
        case PayoutModel.Pick12:
        case PayoutModel.Pick16:
            Component = PickXPrizeCard;
            break;
        case PayoutModel.Assets:
            Component = PrizeAssetPrizeCard;
            break;
        default:
            Component = PickXPrizeCard;
    }

    return <Component ref={ref}
                      parlay={parlay}
                      showDecimal={showDecimal}/>;
});

const PickXPrizeCard = forwardRef(({parlay, showDecimal}, ref) => {

    const tr = "lobbyView.contests.prePackageContest.prePackageContestCard";
    const locale = useSelector(selectLocale);

    const Calculator = parlay.ContestIds.length === 12 ? Pick12PayoutCalculator : Pick16PayoutCalculator;
    const {data:rollingPrize} = useGetRollingPrizeQuery({
        currency: parlay.FeeCurrency,
        wager: parlay.Fee,
        sportId: parlay.SportIds[0],
        payoutModel: parlay.PayoutModel });
    const payoutInfos = new Calculator().calculateDistribution(parlay.Fee, rollingPrize?.RollingAmount || 0.0);
    const last = _.last(payoutInfos);

    const theCultureLg = useSelector(selectUserCultureLg);

    const isPast = (dateString) => {
        const inputDate = moment(dateString);
        const currentDate = moment();
        return inputDate.isBefore(currentDate);
    }


    return(
        <div ref={ref}
             className={`PreSelectedPrizeCard ${getLeagueBySportId(parlay.Name.en, parlay.SportIds[0])}`}
        >
            <div className="parlayTitle">
                <div className="title">{parlay.Name[locale]}</div>
                <div className="subtitle gold-gradient-text">
                    <FormattedMessage
                        id={`lobbyView.betSlip.betSlip.playersStatTitle.${parlay.PayoutModel}`}/> CONTEST
                </div>
            </div>
            <div className="parlayDate">
                {!parlay.IsCancel && <div className="tournamentTimer">
                    {!isPast(parlay.DateStart) && <p><FormattedMessage id={"timer.startsIn"}/></p>}
                    <TournamentTimer targetDate={new Date(parlay.DateStart)}
                                     timeOutLabel={<FormattedMessage id={"timer.closed"}/>}
                                     cultureLg={theCultureLg}/>
                </div>}
                {parlay?.IsCancel && <ParlayCancelled parlay={parlay} showReason={true}/>}
            </div>
            <div className="prize">
                <PrizeSlotsCounter toAmount={last.payout}
                                                    currency={parlay.FeeCurrency}
                                                    showDecimal={last.payout < 1000}
                />
            </div>
            <div className="grandPrize gold-gradient-text">
                <FormattedMessage id={`${tr}.grandPrize`}/>
            </div>
            <div className="entryFee">
                <FormattedMessage id={`${tr}.entryFee`}/>${parlay.Fee}
            </div>
        </div>
    )
});

export const PrizeAssetHeader = ({parlay})=>{

    const locale = useSelector(selectLocale);
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));
    const partner = useSelector(state=>selectPartnerById(state, prizeAsset.PartnerId));
    const theCultureLg = useSelector(selectUserCultureLg)
    var isPast = (dateString) => {
        const inputDate = moment(dateString);
        const currentDate = moment();
        return inputDate.isBefore(currentDate);
    }

    if(window.location.toString().includes('test')) {
        isPast = () => false;
        parlay.IsCancel = false;
        parlay.DateStart = moment().add(1, 'days').toDate();
    }

    return <div className="PrizeAssetHeader">
        <div className="topInfos">
            <Link to={"/lobby"} className="backToLobby">{"<"} <FormattedMessage id="lobbyView.createOwnParlayView.backToLobby" /></Link>
            <div className="parlayDate">
                {!parlay.IsCancel && <div className="tournamentTimer">
                    {!isPast(parlay.DateStart) && <p><FormattedMessage id={"timer.startsIn"}/></p>}
                    <TournamentTimer targetDate={new Date(parlay.DateStart)}
                                     timeOutLabel={<FormattedMessage id={"timer.closed"}/>}
                                     cultureLg={theCultureLg}/>
                </div>}
                {parlay?.IsCancel && <ParlayCancelled parlay={parlay} showReason={true}/>}
            </div>
        </div>

        <div className="title">{parlay.Name[locale]}</div>
        <div className="subtitle gold-gradient-text">
            <FormattedMessage id={`components.prizeAssetCard.subtitle`}/>
            {partner && <div>
                <a href={partner.Website} target="_blank" rel="noreferrer" className="partnerLink">
                    {partner.Logo ? <div className="partnerLogo" style={{backgroundImage:`url("data:image/png;base64,${partner.Logo}")`}}></div>
                        : <span className="partnerName">{partner.Name}</span>} </a></div>}
        </div>

    </div>

}

const PrizeAssetPrizeCard = forwardRef(({parlay}, ref) => {
    const isMobile = window.innerWidth <= 768;
    const locale = useSelector(selectLocale);
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));
    const partner = useSelector(state=>selectPartnerById(state, prizeAsset.PartnerId));
    const name = prizeAsset[`Name${_.capitalize(locale)}`] || "";

    return <div ref={ref}
         className={`PreSelectedPrizeCard prizeAsset ${getLeagueBySportId(parlay.Name.en, parlay.SportIds[0])}`}
         style={{
             backgroundImage: `linear-gradient(rgba(16, 27, 34, 0.8), rgba(16, 27, 34, 0.8)),url("data:image/png;base64,${prizeAsset.BackgroundPicture}")`}}
    >
        <div className="parlayTitle">
            {isMobile && <div className="partner-details">

                <FormattedMessage id={`components.prizeAssetCard.subtitle`}/>
                {partner && <div>
                    <a href={partner.Website} target="_blank" rel="noreferrer" className="partnerLink">
                        {partner.Logo ? <div className="partnerLogo" style={{backgroundImage:`url("data:image/png;base64,${partner.Logo}")`}}></div>
                            : <span className="partnerName">{partner.Name}</span>} </a></div>}


            </div>}
            {name && <div className={"prizeName " + (isMobile ? "gold-gradient-text" : "")}><FormattedMessage id={`components.prizeAssetCard.win`}/> {name}</div>}
            <div className={"picture main"} style={{backgroundImage: `url("data:image/png;base64,${prizeAsset.Pictures[0].PrizeAssetPicture}")`}}></div>
        </div>
    </div>
});

export default PreSelectedPrizeCard;